// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"0494d4df","529":"4b8e8db1","538":"4dd8e04d","735":"7d4afe26","791":"d582b1dd","944":"cee56f9f"}[chunkId] + ".chunk.js";
};